<template>
  <div class="">
    <img :src="png">
  </div>
</template>

<script>
const png1 = require('../image/0.png')
const png2 = require('../image/0.png')
const png3 = require('../image/0.png')
export default {
  name: 'WeHeaderView',
  props: {
    templateId: [String, Number]
  },
  data() {
    return {
      png1,
      png2,
      png3
    }
  },
  computed: {
    png() {
      return ({
        1: this.png1,
        2: this.png2,
        3: this.png3
      })[this.templateId]
    }
  }
}
</script>
